export default __webpack_public_path__ + "static/media/fund-view.522f7fa9.svg";